/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalidupgradeerror2Inputs */

const en_invalidupgradeerror2 = /** @type {(inputs: Invalidupgradeerror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This plan change is not available. You can only upgrade to a higher tier.`)
};

const de_invalidupgradeerror2 = /** @type {(inputs: Invalidupgradeerror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Planwechsel ist nicht verfügbar. Du kannst nur auf einen höheren Plan wechseln.`)
};

/**
* | output |
* | --- |
* | "This plan change is not available. You can only upgrade to a higher tier." |
*
* @param {Invalidupgradeerror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invalidupgradeerror2 = /** @type {((inputs?: Invalidupgradeerror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalidupgradeerror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invalidupgradeerror2(inputs)
	return de_invalidupgradeerror2(inputs)
});
export { invalidupgradeerror2 as "invalidUpgradeError" }